<template>
  <div :class="componentClassName">
    <div class="t-vdxb-application-invite-user-registration-complete__logo">
      <a-vdxb-brand-logo variant="horizontal" />
    </div>
    <div class="t-vdxb-application-invite-user-registration-complete__content">
      <a-vdxb-application-complete-sign class="t-vdxb-application-invite-user-registration-complete__image" />
      <a-vdxb-heading
        heading="お申し込みが完了しました"
        color="primary"
        size="large"
        class="t-vdxb-application-invite-user-registration-complete__heading"
      />
      <a-vdxb-text class="t-vdxb-application-invite-user-registration-complete__text">
        このたびはお申し込みありがとうございました。<br />
        契約者様のご本人確認をお待ちください。
      </a-vdxb-text>
      <!--
      <a-vdxb-button
        id="goTop"
        variant="block"
        color="primary"
        label="サイトトップへ"
        class="t-vdxb-application-invite-user-registration-complete__button"
        @click="handleGoToHome"
      />
      -->
    </div>
    <o-global-footer class="t-vdxb-application-invite-user-registration-complete__footer" />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AVdxbApplicationCompleteSign from '@/components/atoms/vdxb-application-complete-sign';
import AVdxbBrandLogo from '@/components/atoms/vdxb-brand-logo';
import AVdxbButton from '@/components/atoms/vdxb-button';
import AVdxbHeading from '@/components/atoms/vdxb-heading';
import AVdxbText from '@/components/atoms/vdxb-text';
import OGlobalFooter from '@/components/organisms/global-footer';
import { LP_URL } from '@/libs/constants';
import { customRequest } from '@/common/customRequest.js';
import { utils } from '@/common/utils.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 't-vdxb-application-invite-user-registration-complete',
  components: {
    AVdxbApplicationCompleteSign,
    AVdxbBrandLogo,
    // AVdxbButton,
    AVdxbHeading,
    AVdxbText,
    OGlobalFooter,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // handleGoToHome: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      tmpUUID: '',
      tmpYMD: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-application-invite-user-registration-complete');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async mounted() {
    document.title = 'COTOHA Voice DX Basic';

    utils.setMetaDescription(this.$route);
    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: '/vdxbsignup' });
      return; // #2314
    }
    await this.deleteAllCookies();
  },
  methods: {
    handleGoToHome() {
      window.location.href = LP_URL;
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.processingCookiesError);
        });
    },
    deleteAllCookies: async function () {
      await this.postRequest('/signup/deleteAllCookies')
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.$router.push({ path: '/vdxbsignup' });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.processingCookiesError);
        });
    },
  },
};
</script>
